import { render, staticRenderFns } from "./ThemesEditorCssGroupsMenu.vue?vue&type=template&id=12a9c592"
import script from "./ThemesEditorCssGroupsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorCssGroupsMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports